import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * 复选框对象
 *
 * @export
 * @interface ICheckboxObj
 */
export interface ICheckboxObj {
    selected: boolean; // 复选框选中状态
    name: string; // 复选框名称
    [propName: string]: any;
}

@Component({
    selector: 'clink-beyond-content-tooltip',
    templateUrl: './beyond-content-tooltip.component.html',
    styleUrls: ['./beyond-content-tooltip.component.less'],
})
export class BeyondContentTooltipComponent {
    @Input()
    set listObj(checkboxArr: Array<ICheckboxObj>) {
        if (Object.prototype.toString.call(checkboxArr) === '[object Array]') {
            this._listObj = checkboxArr.map((element: any) => {
                const { selected, name } = element;
                return { selected: Boolean(selected), name };
            });
        } else {
            this._listObj = [];
        }
    }
    get listObj(): Array<ICheckboxObj> {
        return this._listObj;
    }
    @Input() disabled = false; // 是否只读
    @Output() selectedEmit = new EventEmitter(); // 传参

    _listObj: Array<ICheckboxObj> = []; // 复选框数据

    constructor() {}

    /**
     * 多选框勾选变更
     */
    changeValue(): void {
        const checkedBoxes: Array<string> = [];
        this.listObj?.forEach((element: any) => {
            const { name, selected } = element;
            if (selected) {
                checkedBoxes.push(name);
            }
        });
        this.selectedEmit.emit(checkedBoxes);
    }
}
